import { Box, Radio } from "@mui/material";
import { useTheme } from "@mui/material";

import { colors } from "@/Utils";

import { Span } from "../Typography/Typography";

export const SortRadioWithTwoOption = ({ status, onChange, label }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: 16,
        position: "relative",
      }}
      data-testcomp="RadioButton"
    >
      <Radio
        type="radio"
        name="radio"
        value={status}
        checked={status}
        onChange={onChange}
        sx={{
          opacity: 0,
          zIndex: 1,
          borderRadius: "50%",
          width: 16,
          height: 16,
          "&:hover ~ .radio-button-label": {
            "&::after": {
              content: '""',
              display: "block",
              borderRadius: "50%",
              width: 9,
              height: 9,
              margin: 3,
              background: "#eeeeee",
            },
          },
          "&:checked + .radio-button-label": {
            "&::after": {
              content: '""',
              display: "block",
              borderRadius: "50%",
              width: 9,
              height: 9,
              margin: 1,
              boxShadow: "1px 3px 3px 1px rgba(0, 0, 0, 0.1)",
              border: "2px solid black",
              background: "white",
            },
          },
        }}
      />
      <Box
        className="radio-button-label"
        component="label"
        sx={{
          position: "absolute",
          width: 15,
          height: 15,
          borderRadius: "50%",
          background: "transparent",
          border: `1px solid ${theme.palette.mode === "dark" ? colors.white : colors.lightBlack}`,
        }}
      />
      <Span fSize={10} pdtop={1} mrleft={3}>
        {label}
      </Span>
    </Box>
  );
};
